import React, { useState, useEffect } from 'react';
import { useCart } from '../context/CartContext';
import OnScreenKeyboard from '../components/Common/OnScreenKeyboard';
import SideNavButtons from '../components/Common/SideNavButtons';
import CategoryHeading from '../components/Common/CategoryHeading';
import SimpleNameAutocomplete from '../components/DogTags/SimpleNameAutocomplete';
import { useNavigate } from 'react-router-dom';
import '../styles/DogTags.css';

const DogTags = () => {
  const [lines, setLines] = useState(['', '', '', '', 'DRIVEATANK.COM']);
  const [currentStep, setCurrentStep] = useState(0); // 0: start, 1: line1, 2: line2, 3: line3, 4: line4, 5: complete
  const { addToCatalogCart, removeFromCatalogCart, catalogItems } = useCart();
  const maxCharsPerLine = 15;
  
  const DOG_TAG_PRICE = 10;
  const DOG_TAG_ID = 'custom-dog-tag';
  const FIXED_LINE_5 = 'DRIVEATANK.COM';

  const handleLineChange = (index, value) => {
    console.log(`=== SETTING LINE ${index + 1} ===`, { index, value: `"${value}"` });
    const limitedValue = value.slice(0, maxCharsPerLine);
    const newLines = [...lines];
    newLines[index] = limitedValue;
    setLines(newLines);
    console.log('=== NEW LINES STATE ===', newLines);
  };

  const handleNextStep = () => {
    if (currentStep < 5) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePreviousStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleGetStarted = () => {
    setCurrentStep(1);
  };

  const handleClearAll = () => {
    setLines(['', '', '', '', FIXED_LINE_5]);
    setCurrentStep(0);
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleNextStep();
    }
  };

  const isDogTagInCart = catalogItems.some(item => item.id === DOG_TAG_ID);

  const handleAddToCart = () => {
    const nonEmptyLines = lines.filter(line => line.trim() !== '');
    if (nonEmptyLines.length === 0) {
      alert('Please enter some text for your dog tag');
      return;
    }

    const infoText = lines.map(line => line.trim().toUpperCase()).join(',');
    const displayText = lines.map(line => line.trim().toUpperCase()).join(',');
    const titleText = displayText !== ',,,,' ? `Dog Tag: ${displayText}` : 'Custom Dog Tag';
    
    const dogTagItem = {
      id: DOG_TAG_ID,
      title: titleText,
      description: 'Personalized engraved dog tag',
      price: DOG_TAG_PRICE,
      type: 'dogtag',
      image: '/img/DogTags.png',
      info: infoText,
      lines: [...lines]
    };

    addToCatalogCart(dogTagItem);
  };

  const handleRemoveFromCart = () => {
    removeFromCatalogCart(DOG_TAG_ID);
  };

  const [isMobile, setIsMobile] = useState(false);
  // const [currentInputIndex, setCurrentInputIndex] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const checkIfMobile = () => setIsMobile(window.innerWidth <= 768);
    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);
    return () => window.removeEventListener("resize", checkIfMobile);
  }, []);

  const handleKeyboardEnter = () => {
    if (currentStep >= 1 && currentStep <= 4) {
      handleNextStep();
    }
  };

  const handleInputFocus = (index) => {
    // setCurrentInputIndex(index);
  };

  const renderStepContent = () => {
    switch (currentStep) {
      case 0:
        return (
          <div style={{ textAlign: 'center', padding: '2rem' }}>
            <h2 style={{ color: '#e6c618', marginBottom: '1rem' }}>Custom Dog Tags</h2>
            <p style={{ color: '#ccc', marginBottom: '2rem', fontSize: '1.2rem' }}>
              Create your personalized engraved dog tag for ${DOG_TAG_PRICE}
            </p>
            <button className="dogtag-button primary" onClick={handleGetStarted}>
              Get Started
            </button>
          </div>
        );
      
      case 1:
        return (
          <div className="input-line">
            <label htmlFor="line-0">Line 1 (Last Name):</label>
            <SimpleNameAutocomplete
              value={lines[0]}
              onChange={(value) => handleLineChange(0, value)}
              onNameSelect={(nameData) => {
                console.log('=== DOGTAGS RECEIVED LINE 1 ===', nameData);
                console.log('Setting Line 1 (Last Name) to:', `"${nameData.lastName}"`);
                console.log('Setting Line 2 (First Name) to:', `"${nameData.firstName}"`);
                
                // Update both lines in a single state update to prevent race condition
                const newLines = [...lines];
                newLines[0] = nameData.lastName.slice(0, maxCharsPerLine);
                newLines[1] = nameData.firstName.slice(0, maxCharsPerLine);
                setLines(newLines);
                
                console.log('=== UPDATED BOTH LINES ===', newLines);
              }}
              placeholder="Last Name"
              className="dogtag-input"
            />
            <span className="char-count">
              {lines[0].length}/{maxCharsPerLine}
            </span>
            
            <div style={{ marginTop: '1rem', display: 'flex', gap: '1rem' }}>
              <button className="dogtag-button secondary" onClick={handlePreviousStep}>
                Back
              </button>
              <button className="dogtag-button primary" onClick={handleNextStep}>
                Next
              </button>
            </div>
          </div>
        );
      
      case 2:
        return (
          <div className="input-line">
            <label htmlFor="line-1">Line 2 (First Name):</label>
            <SimpleNameAutocomplete
              value={lines[1]}
              onChange={(value) => handleLineChange(1, value)}
              onNameSelect={(nameData) => {
                console.log('=== DOGTAGS RECEIVED ===', nameData);
                console.log('Setting Line 1 (Last Name) to:', `"${nameData.lastName}"`);
                console.log('Setting Line 2 (First Name) to:', `"${nameData.firstName}"`);
                
                // Update both lines in a single state update to prevent race condition
                const newLines = [...lines];
                newLines[0] = nameData.lastName.slice(0, maxCharsPerLine);
                newLines[1] = nameData.firstName.slice(0, maxCharsPerLine);
                setLines(newLines);
                
                console.log('=== UPDATED BOTH LINES ===', newLines);
              }}
              placeholder="First Name Middle Initial"
              className="dogtag-input"
            />
            <span className="char-count">
              {lines[1].length}/{maxCharsPerLine}
            </span>
            <div style={{ marginTop: '1rem', display: 'flex', gap: '1rem' }}>
              <button className="dogtag-button secondary" onClick={handlePreviousStep}>
                Back
              </button>
              <button className="dogtag-button primary" onClick={handleNextStep}>
                Next
              </button>
            </div>
          </div>
        );
      
      case 3:
        return (
          <div className="input-line">
            <label htmlFor="line-2">Line 3:</label>
            <input
              id="line-2"
              type="text"
              value={lines[2]}
              onChange={(e) => handleLineChange(2, e.target.value)}
              onKeyDown={(e) => handleKeyDown(e, 2)}
              onFocus={() => handleInputFocus(2)}
              maxLength={maxCharsPerLine}
              placeholder="Event Date (Suggested)"
              className="dogtag-input"
              autoFocus
            />
            <span className="char-count">
              {lines[2].length}/{maxCharsPerLine}
            </span>
            <button 
              type="button"
              className="dogtag-button secondary"
              onClick={() => {
                const today = new Date();
                const formattedDate = `${(today.getMonth() + 1).toString().padStart(2, '0')}/${today.getDate().toString().padStart(2, '0')}/${today.getFullYear()}`;
                handleLineChange(2, formattedDate);
              }}
              style={{ marginTop: '0.5rem', alignSelf: 'flex-start' }}
            >
              Today's Date
            </button>
            <div style={{ marginTop: '1rem', display: 'flex', gap: '1rem' }}>
              <button className="dogtag-button secondary" onClick={handlePreviousStep}>
                Back
              </button>
              <button className="dogtag-button primary" onClick={handleNextStep}>
                Next
              </button>
            </div>
          </div>
        );
      
      case 4:
        return (
          <div className="input-line">
            <label htmlFor="line-3">Line 4:</label>
            <input
              id="line-3"
              type="text"
              value={lines[3]}
              onChange={(e) => handleLineChange(3, e.target.value)}
              onKeyDown={(e) => handleKeyDown(e, 3)}
              onFocus={() => handleInputFocus(3)}
              maxLength={maxCharsPerLine}
              placeholder="Package/Position (Suggested)"
              className="dogtag-input"
              autoFocus
            />
            <span className="char-count">
              {lines[3].length}/{maxCharsPerLine}
            </span>
            <div style={{ marginTop: '0.5rem', display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
              <button 
                type="button"
                className="dogtag-button secondary"
                onClick={() => handleLineChange(3, 'LT. GENERAL')}
                style={{ padding: '0.5rem 1rem', fontSize: '0.9rem' }}
              >
                3 Star Lt. General
              </button>
              <button 
                type="button"
                className="dogtag-button secondary"
                onClick={() => handleLineChange(3, 'GENERAL')}
                style={{ padding: '0.5rem 1rem', fontSize: '0.9rem' }}
              >
                4 Star General
              </button>
              <button 
                type="button"
                className="dogtag-button secondary"
                onClick={() => handleLineChange(3, 'COMMANDER')}
                style={{ padding: '0.5rem 1rem', fontSize: '0.9rem' }}
              >
                5 Star Commander-in-Chief
              </button>
              <button 
                type="button"
                className="dogtag-button secondary"
                onClick={() => handleLineChange(3, 'ULTIMATE')}
                style={{ padding: '0.5rem 1rem', fontSize: '0.9rem' }}
              >
                Ultimate
              </button>
            </div>
            <div style={{ marginTop: '1rem', display: 'flex', gap: '1rem' }}>
              <button className="dogtag-button secondary" onClick={handlePreviousStep}>
                Back
              </button>
              <button className="dogtag-button primary" onClick={handleNextStep}>
                Next
              </button>
            </div>
          </div>
        );
      
      case 5:
        return (
          <div>
            <h3 style={{ color: '#e6c618', marginBottom: '1rem' }}>Review Your Dog Tag</h3>
            <div style={{ backgroundColor: '#222', padding: '1rem', borderRadius: '4px', marginBottom: '1rem' }}>
              {lines.slice(0, 4).map((line, index) => (
                <div key={index} style={{ color: '#fff', fontFamily: 'Courier New, monospace', marginBottom: '0.5rem', textTransform: 'uppercase' }}>
                  Line {index + 1}: {line.toUpperCase() || <span style={{ color: '#888' }}>EMPTY</span>}
                </div>
              ))}
            </div>
            <div className="dogtag-actions">
              {isDogTagInCart ? (
                <button
                  className="dogtag-button secondary"
                  onClick={handleRemoveFromCart}
                >
                  Remove from Cart
                </button>
              ) : (
                <button
                  className="dogtag-button primary"
                  onClick={handleAddToCart}
                >
                  Add to Cart - ${DOG_TAG_PRICE}
                </button>
              )}
              <button
                className="dogtag-button secondary"
                onClick={handlePreviousStep}
              >
                Back
              </button>
            </div>
          </div>
        );
      
      default:
        return null;
    }
  };

  return (
    <div className="dogtags-container">
      <CategoryHeading 
        title="Custom Dog Tags" 
        description={`Create your personalized engraved dog tag - $${DOG_TAG_PRICE} each`} 
      />

      <div className="dogtags-content">
        <div className="dogtag-preview">
          <div className="dogtag-image-container">
            <img 
              src="/img/DogTags.png" 
              alt="Dog Tags" 
              className="dogtag-image"
            />
            <div className="dogtag-text-overlay">
              {lines.map((line, index) => (
                <div key={index} className={`dogtag-line line-${index + 1}`}>
                  {line || '••••••••••••••••'}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="dogtag-inputs">
          <h3 style={{ color: '#e6c618', margin: '0 0 1rem 0' }}>
            {currentStep === 0 ? '' : `Step ${currentStep} of 4`}
          </h3>
          
          {renderStepContent()}
          
          {currentStep > 0 && (
            <div style={{ marginTop: '2rem', textAlign: 'center' }}>
              <button
                className="dogtag-button secondary"
                onClick={handleClearAll}
                style={{ padding: '0.75rem 1.5rem', fontSize: '1rem' }}
              >
                Clear All
              </button>
            </div>
          )}
        </div>
      </div>

      <SideNavButtons
        onPrev={() => navigate('/items-catalog')}
        onNext={() => navigate('/vehicles')}
        prevPageName="MACHINE GUNS"
        nextPageName="VEHICLES"
        showPrev={true}
        showNext={true}
      />

      {!isMobile && (
        <OnScreenKeyboard
          isVisible={true}
          isDogTagMode={true}
          onKeyPress={(button) => {
            if (button === "{enter}") {
              handleKeyboardEnter();
            }
          }}
        />
      )}
    </div>
  );
};

export default DogTags;
